export default class ShowWorkDayController {
  /** @ngInject */
  constructor(
    $log, $mdDialog,
    moment,
    UtilService,
    workDay
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.moment = moment;
    this.UtilService = UtilService;
    this.workDay = workDay;

    this.date = this.moment(this.workDay.date).toDate();
    if (this.workDay.workingHourStart) {
      this.startTime = this.moment(this.UtilService.parseTime(this.workDay.workingHourStart)).format('HH:mm');
    }

    if (this.workDay.workingHourEnd) {
      this.endTime = this.moment(this.UtilService.parseTime(this.workDay.workingHourEnd)).format('HH:mm');
    }
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
